export default __webpack_public_path__ + "static/media/library-1.efb0ee22.webp";